import React from "react";
import { Row, Col, Button } from "antd";
import loginBg from "../../../../images/unauthorised.svg";
import { useAuth } from "../../../contexts/auth/index";
const styles = {
  loginPage: {
    height: "100%",
  },

  bgLogin: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "60%",
  },
};

const UnAuthorised = () => {
  const auth = useAuth();

  return (
    <Row gutter={32} style={{ height: "100%" }}>
      <Col span={24}>
        <div
          style={{
            ...styles.bgLogin,
            backgroundImage: `url(${loginBg})`,
            height: "80%",
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <h1 style={{ color: "#3F3D56", fontSize: 24 }}>
            Looks like you don't have permissions here.
          </h1>
          <h1 style={{ color: "#3F3D56", fontSize: 24 }}>
            Let's{" "}
            <Button
              type="link"
              onClick={() => auth.logout()}
              style={{ fontSize: 24 }}
            >
              Logout
            </Button>{" "}
            and Contact Support.
          </h1>
        </div>
      </Col>
    </Row>
  );
};

export default UnAuthorised;
